import {
  StyledCampaignCode,
  StyledContainer,
} from 'components/Campaign/Toast/CampaignToast.Styled'

type Props = {
  campaignCode: string
  message: string
}

export const CampaignToast = ({ campaignCode, message }: Props) => {
  return (
    <StyledContainer>
      <div>{message}</div>
      <StyledCampaignCode>{campaignCode}</StyledCampaignCode>
    </StyledContainer>
  )
}
